(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/self-exclusion-react/assets/react/components/set-self-exclusion.js') >= 0) return;  svs.modules.push('/modules/self-exclusion-react/assets/react/components/set-self-exclusion.js');
'use strict';

const {
  useAtom
} = jotai;
const {
  Games,
  Periods,
  NativeApp
} = svs.selfExclusion.components;
const {
  ReactButton: Button
} = svs.ui;
const {
  Form
} = svs.ui.reactForm;
const {
  useState
} = React;
const {
  DOCS,
  isNativeApp
} = svs.selfExclusion.Constants;
const {
  DataService
} = svs.accountservices.player_exclusions;
const {
  activeExclusionsAtom,
  isNaExcludedAtom
} = svs.selfExclusion.store.selfExclusionAtoms;
const SetSelfExclusion = () => {
  const [game, setGame] = useState();
  const [period, setPeriod] = useState();
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [activeExclusions, setActiveExclusions] = useAtom(activeExclusionsAtom);
  const [, setNaExcluded] = useAtom(isNaExcludedAtom);
  const exclusionDates = svs.selfExclusion.useExpiryDate(activeExclusions, game);
  const setExclusion = eidType => {
    DataService.setSelfExclusion(game, period, setActiveExclusions, setNaExcluded, eidType);
    setIsSubmitted(false);
    setGame();
    setPeriod();
  };
  const handleSubmit = e => {
    e.preventDefault();
    setIsSubmitted(true);
    if (!game || !period) {
      return;
    }
    svs.selfExclusion.showEidDialog(setExclusion);
  };
  const handleGame = gameValue => {
    setGame(gameValue);
    setPeriod();
    setIsSubmitted(false);
  };
  const handlePeriod = periodValue => {
    setPeriod(periodValue);
    setIsSubmitted(false);
  };
  return React.createElement(React.Fragment, null, React.createElement("section", {
    className: "exclusion-pause-wrapper padding-xs-h-1 padding-xs-bottom-2",
    id: "set-self-exclusions"
  }, React.createElement(Form, {
    "aria-live": "polite",
    onSubmit: handleSubmit
  }, React.createElement("h2", {
    className: "align-center f-700 f-bold"
  }, "Spelpaus i 3 m\xE5nader - 3 \xE5r"), React.createElement(Games, {
    game: game,
    isSubmitted: isSubmitted,
    onHandleGame: handleGame
  }), React.createElement(Periods, {
    exclusionDates: exclusionDates,
    exclusions: activeExclusions,
    isSubmitted: isSubmitted,
    onHandlePeriod: handlePeriod,
    period: period
  }), React.createElement("p", null, "Genom att aktivera en l\xE4ngre spelpaus godk\xE4nner du", ' ', isNativeApp ? React.createElement(NativeApp, null) : React.createElement("a", {
    className: "fc-sport-75",
    href: DOCS.PERSONAL_INFORMATION,
    rel: "noreferrer",
    target: "_blank"
  }, "villkoren f\xF6r spelpaus"), ' ', "och bekr\xE4ftar att du tagit del av", ' ', React.createElement("a", {
    className: "fc-sport-75",
    href: DOCS.PERSONAL_POLICY,
    rel: "noreferrer",
    target: "_blank"
  }, "information om behandling av personuppgifter."), ' '), React.createElement(Button, {
    block: true,
    inverted: true,
    size: 300,
    type: "submit"
  }, "Pausa"))), React.createElement("hr", {
    "aria-hidden": true,
    className: "exclusion-border-bottom"
  }));
};
svs.selfExclusion.components.SetSelfExclusion = SetSelfExclusion;

 })(window);